import { render, staticRenderFns } from "./laboratory-process-modal.vue?vue&type=template&id=6c6c2c66&"
import script from "./laboratory-process-modal.ts?vue&type=script&lang=ts&"
export * from "./laboratory-process-modal.ts?vue&type=script&lang=ts&"
import style0 from "./laboratory-process-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports